var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInviteDum2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2363 41.9916H40.9916V53.2363C40.9916 54.4732 39.9795 55.4852 38.7426 55.4852C37.5057 55.4852 36.4937 54.4732 36.4937 53.2363V41.9916H25.2489C24.012 41.9916 23 40.9795 23 39.7426C23 38.5057 24.012 37.4937 25.2489 37.4937H36.4937V26.2489C36.4937 25.012 37.5057 24 38.7426 24C39.9795 24 40.9916 25.012 40.9916 26.2489V37.4937H52.2363C53.4732 37.4937 54.4852 38.5057 54.4852 39.7426C54.4852 40.9795 53.4732 41.9916 52.2363 41.9916Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteDum2);
export default __webpack_public_path__ + "static/media/inviteDum2.3b9bdd8622baefe765b30d4dab9c4db9.svg";
export { ForwardRef as ReactComponent };